const defaultRender = value => value;

export default defaultRender;
